import { Link } from 'react-router';

import type { LandingContent, LandingLanguage } from './landingContent';

const contactEmail = 'hello@jeeum.space';

interface LandingFooterProps {
  language: LandingLanguage;
  footer: LandingContent['footer'];
  guideLabel: LandingContent['nav']['guides'];
  guidePath: LandingContent['guideHubPath'];
}

export default function LandingFooter({
  language,
  footer,
  guideLabel,
  guidePath,
}: LandingFooterProps) {
  const legalLanguage = language === 'ko' ? 'ko' : 'en';

  return (
    <footer className="landing-footer">
      <nav className="landing-footer-links" aria-label={footer.support}>
        <Link to={`/${language}/blog`} reloadDocument>{footer.blog}</Link>
        {guidePath ? <Link to={guidePath} reloadDocument>{guideLabel}</Link> : null}
        <Link to={language === 'ko' ? '/business' : '/en/business'} reloadDocument>
          {language === 'ko' ? '비즈니스' : 'For business'}
        </Link>
        <a href={`/${legalLanguage}/privacy`}>{footer.privacy}</a>
        <a href={`/${legalLanguage}/terms`}>{footer.terms}</a>
        <a href={`/${legalLanguage}/support`}>{footer.support}</a>
      </nav>
      <a
        className="landing-footer-contact"
        href={`mailto:${contactEmail}`}
        aria-label={`${footer.contact}: ${contactEmail}`}
      >
        <span>{footer.contact}: </span>
        <span>{contactEmail}</span>
      </a>
    </footer>
  );
}
